
import Vue from 'vue'
import {Component, Prop, Model, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'

const refModule = namespace('ref')

@Component
export default class SelectRef extends Vue {
  @Prop(String) name!: string
  @Prop(String) placeholder!: string
  @Prop() value!: any

  @refModule.Getter('refGetter') refObject: any
  @refModule.Action('getRefAction') getRef: any

  get options() {
    return this.refObject[this.name] || []
  }

  get selected() {
    return this.value
  }

  set selected(v) {
    this.$emit('input', v)
  }

  mounted() {
    if (!this.refObject[this.name]) {
      this.getRef(this.name)
    }
  }

  onChangeHandler(e) {
    this.$emit('change', e)
  }
}
